import Select from "react-select";
import "../Styles/EducationWorkForm.css";
import CURRENCY_META from "../components/currencyMeta";

const EducationWorkForm = ({
  qualifications,
  selectedQualification,
  handleQualificationDataFromChild,
  collageName,
  setCollageName,
  jobRole,
  setJobRole,
  Salary,
  setSalary,
  carrerGoals,
  setcarrerGoals,
  salaryCurrency,
  setSalaryCurrency,
  allCountyMasterData,
}) => {
  // Build currency options from countries data — deduplicate by currency code
  const currencyOptions = allCountyMasterData
    ? Array.from(
        new Map(
          allCountyMasterData
            .filter((c) => c.currency)
            .map((c) => [c.currency, { code: c.currency, flag: c.flag }]),
        ).values(),
      )
        .map((c) => ({
          ...c,
          symbol: CURRENCY_META[c.code]?.symbol || c.code,
          name: CURRENCY_META[c.code]?.name || c.code,
        }))
        .sort((a, b) => a.code.localeCompare(b.code))
    : [];

  // Format for react-select
  const selectOptions = currencyOptions.map((c) => ({
    value: c.code,
    label: `${c.flag} ${c.symbol} — ${c.name}`,
    ...c,
  }));

  const selectedOption =
    selectOptions.find((o) => o.value === salaryCurrency) || null;

  console.log(selectedOption);

  const isINR = selectedOption?.code === "INR";
  const selected = currencyOptions.find((c) => c.code === salaryCurrency);

  return (
    <div className="form-wrapper">
      <h2 className="background-section__title">Education & Work</h2>

      <div className="form-group">
        <label className="form-label">Education Qualification *</label>
        <select
          className="form-select"
          onChange={handleQualificationDataFromChild}
          value={selectedQualification}
        >
          <option value="">Select Qualification</option>
          {qualifications.map((q) => (
            <option key={q.QualificationId} value={q.QualificationId}>
              {q.QualificationName}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Enter College Name</label>
        <textarea
          className="form-textarea"
          placeholder="Enter College Name"
          maxLength={50}
          value={collageName}
          onChange={(e) => setCollageName(e.target.value)}
        />
        <div className="form-char-count">{collageName?.length}/300</div>
      </div>

      <div className="form-group">
        <label className="form-label">Work As</label>
        <textarea
          value={jobRole}
          onChange={(e) => setJobRole(e.target.value)}
          className="form-textarea"
          placeholder="Work As"
        />
      </div>

      {/* ── Salary Row ── */}
      <div className="form-group">
        <label className="form-label">Salary</label>

        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          {/* Currency Selector — react-select with search */}
          <Select
            options={selectOptions}
            value={selectedOption}
            onChange={(option) => setSalaryCurrency(option ? option.value : "")}
            placeholder="Search currency..."
            isClearable
            isSearchable
            styles={{
              container: (base) => ({
                ...base,
                width: "250px",
                flexShrink: 0,
              }),
              control: (base, { isFocused }) => ({
                ...base,
                minHeight: "38px",
                borderColor: isFocused ? "#4f46e5" : "#ccc",
                boxShadow: isFocused ? "0 0 0 1px #4f46e5" : "none",
                "&:hover": { borderColor: "#4f46e5" },
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected
                  ? "#4f46e5"
                  : isFocused
                    ? "#f0f0f0"
                    : "#fff",
                color: isSelected ? "#fff" : "#333",
                fontSize: "14px",
                cursor: "pointer",
              }),
              singleValue: (base) => ({
                ...base,
                fontSize: "14px",
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: "14px",
                color: "#999",
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
          />

          {/* Amount */}
          {/* <input
            value={Salary}
            onChange={(e) => setSalary(e.target.value)}
            type="number"
            min="0"
            className="form-select"
            placeholder="Enter amount"
            style={{minWidth:300 , maxWidth:350}}
          /> */}

          <input
            value={isINR ? (Salary ? Salary / 100 : "") : Salary}
            onChange={(e) => {
              const value = e.target.value;

              if (value === "") {
                setSalary("");
                return;
              }

              // Always store in K
              setSalary(isINR ? Number(value) * 100 : Number(value));
            }}
            type="number"
            min="0"
            className="form-select"
            placeholder={isINR ? "Enter LPA" : "Enter Salary (K)"}
            style={{ minWidth: 300, maxWidth: 350 }}
          />

          {/* Unit */}
          {/* <select
            className="form-select"
            style={{ width: "150px", flexShrink: 0 }}
          >
            <option value="LPA">LPA (Lakhs/yr)</option>
          </select> */}

          <select
            className="form-select"
            style={{ width: "150px", flexShrink: 0 }}
          >
            <option>{isINR ? "LPA (Lakhs/yr)" : "K"}</option>
          </select>
        </div>

        {/* Live Preview */}
        {/* {Salary && salaryCurrency && (
          <small style={{ color: "#888", marginTop: "4px", display: "block" }}>
            Preview: {selected?.symbol} {Salary} ({selected?.name}) LPA
            (Lakhs/yr)
          </small>
        )} */}
        {Salary && salaryCurrency && (
          <small style={{ color: "#888", marginTop: "4px", display: "block" }}>
            Preview: {selectedOption?.symbol} {isINR ? Salary / 100 : Salary} (
            {selectedOption?.name}) {isINR ? "LPA (Lakhs/yr)" : "K"}
          </small>
        )}
      </div>

      <div className="form-group">
        <label className="form-label">Career Goals (Optional)</label>
        <textarea
          className="form-textarea"
          placeholder="Ex: Wants to open a business in the future"
          value={carrerGoals}
          onChange={(e) => setcarrerGoals(e.target.value)}
        />
        <div className="form-char-count">{carrerGoals?.length}/300</div>
      </div>
    </div>
  );
};

export default EducationWorkForm;
